import * as db from '../../db'
import _ from 'lodash'

export const RECEIVE_FLOORPLANS = 'RECEIVE_FLOORPLANS'
export const LOADING_FLOORPLANS = 'LOADING_FLOORPLANS'
export const RECEIVE_USER_FLOORPLANS = 'RECEIVE_USER_FLOORPLANS'
export const LOAD_USER_FLOORPLAN = 'LOAD_USER_FLOORPLAN'
export const SAME_PACKAGE = 'SAME_PAKAGE'
export const LOAD_USER_FLOORPLAN_CUSTOME = 'LOAD_USER_FLOORPLAN_CUSTOME'

// initial state
const state = {
  loading: false,
  floorplans: {},
  loadedFloorplan: {},
  userSavedFloorplans: [],
  loadedFloorplanCustome:[],
  samePackage:false
}

// getters
const getters = {
  floorplans: state => _.values(state.floorplans),
  loading: state => state.loading,
  samePackage: state => state.samePackage,
  getSelectedFloorplan: state => route => state.floorplans[route.params.floorplanId],
  getLoadedFloorplan: state => _.values(state.loadedFloorplan),
  getLoadedFloorplanCustome: state => _.values(state.loadedFloorplanCustome),
  getUserSavedFloorplans: state => _.values(state.userSavedFloorplans)
}

// actions
const actions = {
  getFloorplans({ commit }, project) {
    commit(LOADING_FLOORPLANS, true)
    db.projects
      .doc(project)
      .collection('floorplans')
      .onSnapshot(function(snapshot) {
        let floorplans = {}
        snapshot.forEach(function(doc) {
          let floorplan = doc.data()
          floorplan.id = doc.id
          floorplans[floorplan.id] = floorplan
        })
        commit(RECEIVE_FLOORPLANS, { floorplans })
        commit(LOADING_FLOORPLANS, false)
      })
  },

  loadUserSavedFloorplans({ commit }, user) {
    commit(LOADING_FLOORPLANS, true)
    db.users
      .doc(user)
      .get()
      .then(doc => {
        if (!doc.exists) {
          console.log('No such User document!')
          throw new Error('No such User document!')
        } else {
          let floorplans = doc.data().floorplans
          commit(RECEIVE_USER_FLOORPLANS, { floorplans })
          commit(LOADING_FLOORPLANS, false)
          return true
        }
      })
      .catch(e => {
        console.log('Error getting document', e)
        return false
      })
  },
  clearUserFloorplans({ commit}) {
    let floorplans = []
    commit(RECEIVE_USER_FLOORPLANS, { floorplans })
  },
  saveFloorplanNotes({dispatch, commit }, data) {
    let user = data.user
    let floorplan = data.floorplan
    let floorplanName = data.floorplanName
    let notes = data.notes
    let floorplanArray = []
    commit(SAME_PACKAGE, false)
    db.users
      .doc(user)
      .get()
      .then(doc => {
        if (!doc.exists) {
          console.log('No such User document!')
          console.log(1)
          throw new Error('No such User document!')
        } else {

          if (doc.data().hasOwnProperty('floorplans')) {
            floorplanArray = doc.data().floorplans
          }
          if (_.some(floorplanArray, _.matchesProperty('floorplanName', floorplanName))) {
            for (let obj in floorplanArray) {
              if (floorplanArray[obj].floorplanName === floorplanName) {
                console.log(3)
                console.log('floorplanArray[obj].floorplanName', floorplanArray[obj].floorplanName)
                commit(SAME_PACKAGE, false)
                floorplanArray[obj].floorplan = floorplan
                floorplanArray[obj].notes = notes
              }
            }
          } else {
            floorplanArray.push({
              floorplanName: floorplanName,
              floorplan: floorplan,
              notes:notes
            })
          }
        console.log('floorplanArray bal',floorplanArray)
          db.users
          .doc(user)
          .update({
            floorplans: floorplanArray
          })
          .catch(e => {
            console.log(e)
            return
          })
          return true
        }
      })
      .catch(e => {
        console.log('Error getting document', e)
        return false
      })
  },
  saveFloorplan({dispatch, commit }, data) {
    let user = data.user
    let floorplan = data.floorplan
    let floorplanName = data.floorplanName
    let notes = data.notes
    let floorplanArray = []
    commit(SAME_PACKAGE, false)
    db.users
      .doc(user)
      .get()
      .then(doc => {
        if (!doc.exists) {
          console.log('No such User document!')
          console.log(1)
          throw new Error('No such User document!')
        } else {
          if (doc.data().hasOwnProperty('floorplans')) {
            console.log(doc.data().floorplans)
            floorplanArray = doc.data().floorplans
          }
          if (_.some(floorplanArray, _.matchesProperty('floorplanName', floorplanName))) {
            for (let obj in floorplanArray) {
              if (floorplanArray[obj].floorplanName === floorplanName) {
                commit(SAME_PACKAGE, true)
                floorplanArray[obj].floorplan = floorplan
                floorplanArray[obj].notes = notes
                dispatch('loadFloorplanCustome', data)
                console.log('floorplanArray[obj].floorplanName', floorplanArray[obj].floorplanName)
              }
            }
          } else {
            commit(SAME_PACKAGE, false)
            floorplanArray.push({
              floorplanName: floorplanName,
              floorplan: floorplan,
              notes:notes
            })
            console.log('hey')
              db.users
              .doc(user)
              .update({
                floorplans: floorplanArray
              })
              .catch(e => {
                console.log(e)
                return
              })

          }

          return true
        }
      })
      .catch(e => {
        console.log('Error getting document', e)
        return false
      })
  },

  saveFloorplanUpdate({ dispatch, commit }, data) {
    let { user, floorplan, floorplanName, notes } = data;
    let floorplanArray = [];
  
    db.users.doc(user).get()
      .then(doc => {
        if (!doc.exists) {
          throw new Error('No such User document!');
        }
  
        floorplanArray = doc.data().floorplans || [];
  
        // Find the floorplan in the array or create a new one
        let targetFloorplan = floorplanArray.find(fp => fp.floorplanName === floorplanName);
        if (targetFloorplan) {
          targetFloorplan.floorplan = floorplan;
          targetFloorplan.notes = notes;
        } else {
          floorplanArray.push({ floorplanName, floorplan, notes });
        }
  
        return db.users.doc(user).update({ floorplans: floorplanArray });
      })
      .then(() => {
        dispatch('loadFloorplanCustome', data); // Assuming you want to dispatch this in all cases
      })
      .catch(e => {
        console.log('Error:', e);
      });
  },
  
  loadFloorplanCustome({ commit }, data) {
    console.log('data.user',data.user)
    let loadedFloorplan = data
    commit(LOAD_USER_FLOORPLAN_CUSTOME, { loadedFloorplan })
    commit(LOADING_FLOORPLANS, true)
  },
  loadFloorplan({ commit }, data) {
    console.log('ok' ,data)
    console.log('data.user',data.user)
    let user = data.user
    let floorplanName = data.floorplanName
    let floorplanArray = []
    commit(LOADING_FLOORPLANS, true)
    db.users
      .doc(user)
      .get()
      .then(doc => {
        floorplanArray = doc.data().floorplans
        if (!doc.exists) {
          console.log('No such User document!')
          throw new Error('No such User document!')
        } else {
          if (_.some(floorplanArray, _.matchesProperty('floorplanName', floorplanName))) {
            for (let obj in floorplanArray) {
              if (floorplanArray[obj].floorplanName === floorplanName) {
                let loadedFloorplan = floorplanArray[obj]
                commit(LOAD_USER_FLOORPLAN, { loadedFloorplan })
                commit(LOADING_FLOORPLANS, false)
              }
            }
          }
          return true
        }
      })
      .catch(e => {
        console.log('Error getting document', e)
        return false
      })
  },
  deleteSavedFloorplan({ dispatch }, data) {
    console.log(data.user)
    let user = data.user
    let floorplanName = data.floorplanName
		console.log("TCL: deleteSavedFloorplan -> data.floorplanName", data.floorplanName)
    let floorplanArray = []

    db.users
      .doc(user)
      .get()
      .then(doc => {
        if (!doc.exists) {
          console.log('No such User document!')
          throw new Error('No such User document!')
        } else {
          floorplanArray = doc.data().floorplans
					console.log("TCL: deleteSavedFloorplan -> doc.data().floorplans", doc.data().floorplans)
          if (_.some(floorplanArray, _.matchesProperty('floorplanName', floorplanName))) {
						console.log("TCL: deleteSavedFloorplan -> floorplanName MATCH", floorplanName)
            for (let obj in floorplanArray) {
              if (floorplanArray[obj].floorplanName === floorplanName) {
								console.log("TCL: deleteSavedFloorplan -> floorplanArray[obj].floorplanName", floorplanArray[obj].floorplanName)
                // remove the object from the array
                floorplanArray = _.remove(floorplanArray, o => o !== floorplanArray[obj])
              }
            }
          } else {
						console.log("TCL: deleteSavedFloorplan -> else")
          }

          // update the db with the new object
          db.users
            .doc(user)
            .update({
              floorplans: floorplanArray
            })
            .catch(e => {
              console.log(e)
              return
            })

          // refresh the state with the new data from the DB
          dispatch('loadUserSavedFloorplans', data.user)

          return true
        }
      })
      .catch(e => {
        console.log(e)
        return false
      })
  }
}

// mutations
const mutations = {
  [RECEIVE_FLOORPLANS](state, { floorplans }) {
    state.floorplans = floorplans
  },

  [RECEIVE_USER_FLOORPLANS](state, { floorplans }) {
    state.userSavedFloorplans = floorplans
  },
  [LOAD_USER_FLOORPLAN_CUSTOME](state, { loadedFloorplan }) {
    state.loadedFloorplanCustome = loadedFloorplan
  },
  [LOAD_USER_FLOORPLAN](state, { loadedFloorplan }) {
    state.loadedFloorplan = loadedFloorplan
  },
  [SAME_PACKAGE](state, value) {
    state.samePackage = value
  },
  [LOADING_FLOORPLANS](state, value) {
    state.loading = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/floorplan.js